import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import allBookFilter from "../../redux/filters/thunk/allBookFilter";
import featuredFilter from "../../redux/filters/thunk/featuredFilter";

const BookFilter = () => {
  const bookStore = useSelector((state) => state.book);
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setIsActive(bookStore?.filterFeatured);
  }, [bookStore?.filterFeatured]);

  const filterAllHandler = () => {
    dispatch(allBookFilter(false));
  };
  const filterFeatureHandler = () => {
    dispatch(featuredFilter(true));
  };
  return (
    <>
      <div className="flex items-center justify-between mb-12">
        <h4 className="mt-2 text-xl font-bold">Book List</h4>

        <div className="flex items-center space-x-4">
          <button
            onClick={filterAllHandler}
            className={`filter-btn ${!isActive && "active-filter"}`}
            id="lws-filterAll"
          >
            All
          </button>
          <button
            onClick={filterFeatureHandler}
            className={`filter-btn ${isActive && "active-filter"}`}
            id="lws-filterFeatured"
          >
            Featured
          </button>
        </div>
      </div>
    </>
  );
};

export default BookFilter;
